module.exports = __webpack_public_path__ + "static/media/Modlin_Group_Frederique_500.592b7859.jpg";